const AiFooterDivider = () => {
  return <div className="ai6ix-layout-footer-divider"></div>;
};

export default AiFooterDivider;
